// extracted by mini-css-extract-plugin
export default {"glossary_view":"PluginGlossaryView_glossary_view__7f+1Z","download_div":"PluginGlossaryView_download_div__Fix4k"};